import React from "react";
import { TABLE_CELL_CLASS, TABLE_HEAD_CLASS } from "./accountsConstants";

const SKELETON_COLUMNS = [
  { label: "#", class: "h-3 w-5", align: "center" },
  { label: "Name", class: "h-3 w-28" },
  { label: "Role", class: "h-3 w-16", align: "center" },
  { label: "Branch", class: "h-3 w-20", align: "center" },
  { label: "Status", class: "h-4 w-14 rounded-full", align: "center" },
  { label: "IP Check", class: "h-3 w-10", align: "center" },
  { label: "Mobile", class: "h-3 w-20", align: "center" },
  { label: "Team Lead", class: "h-[26px] w-[26px] rounded-md", align: "center" },
  { label: "HR Admin", class: "h-[26px] w-[26px] rounded-md", align: "center" },
  { label: "Actions", class: "h-[26px] w-24 rounded-md", align: "right" },
];

function AccountsTableSkeleton({ rows = 10 }) {
  return (
    <div className="overflow-x-auto" aria-busy="true" aria-label="Loading accounts">
      <table className="w-full min-w-[960px] text-left text-xs">
        <thead className={TABLE_HEAD_CLASS}>
          <tr>
            {SKELETON_COLUMNS.map((col) => (
              <th
                key={col.label}
                className={`${TABLE_CELL_CLASS} ${
                  col.align === "center"
                    ? "text-center"
                    : col.align === "right"
                      ? "text-right"
                      : "text-left"
                }`}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={`accounts-skeleton-${rowIndex}`}>
              {SKELETON_COLUMNS.map((col, colIndex) => (
                <td
                  key={`${col.label}-${rowIndex}`}
                  className={`${TABLE_CELL_CLASS} ${
                    col.align === "center"
                      ? "text-center"
                      : col.align === "right"
                        ? "text-right"
                        : ""
                  }`}
                >
                  <div
                    className={`rounded bg-gradient-to-r from-gray-100 via-gray-200/80 to-gray-100 bg-[length:200%_100%] animate-pulse ${col.class} ${
                      col.align === "center"
                        ? "mx-auto"
                        : col.align === "right"
                          ? "ml-auto"
                          : ""
                    }`}
                    style={{
                      animationDelay: `${(rowIndex * 0.08 + colIndex * 0.04).toFixed(2)}s`,
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AccountsTableSkeleton;
